module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isSupportedGrade) ? _c('CatSubtitle', {
    staticClass: "cl-container",
    attrs: {
      "title": 'common.sam_assignment',
      "eventLabel": 'cat',
      "routeName": 'cat-domain-view'
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "domain-list"
  }, [(_vm.busy) ? _c('div', {
    staticClass: "dummy-domain"
  }, [_vm._m(0)]) : [(!_vm.isSupportedGrade) ? _c('div', {
    staticClass: "not-support-grade"
  }, [_c('div', {
    staticClass: "title px-0"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('common.sam_assignment')) + "\n          "), _c('img', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.previewDomainModal",
      modifiers: {
        "previewDomainModal": true
      }
    }],
    attrs: {
      "src": "/static/images/ic-info-outline-black.svg",
      "alt": "classting-score"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sub-title px-0"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('common.not_support_grade')))])])]) : (_vm.catDomains.length === 0) ? _c('EmptyContent', {
    attrs: {
      "emptyContentText": _vm.$t('common.empty_domain_assignment')
    }
  }) : _vm._l((_vm.catDomains), function(value, index) {
    return _c('div', {
      key: index,
      staticClass: "domain"
    }, [_c('div', {
      staticClass: "domain-subject"
    }, [_c('img', {
      style: ({
        'background': value.color_code
      }),
      attrs: {
        "src": value.icon_url,
        "alt": "subject-icon"
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(value.name))])]), _vm._v(" "), _c('div', {
      staticClass: "domain-title"
    }, [_vm._v("\n          " + _vm._s(value.domain_name) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [(value && !value.cat) ? [_c('div', {
      staticClass: "col-12 domain-action",
      style: ({
        color: value.color_code
      })
    }, [_c('span', {
      on: {
        "click": function($event) {
          return _vm.openCreatedLearningViewer(value.domain_id, true)
        }
      }
    }, [_vm._v("\n                " + _vm._s(_vm.$t('common.first_problem_solve')) + " >\n              ")])])] : (value.cat && value.cat.is_completed) ? [_c('div', {
      staticClass: "col-6 domain-score"
    }, [_c('strong', {
      style: ({
        color: value.color_code
      })
    }, [_vm._v("\n                " + _vm._s(_vm.$t('common.score')) + " \n                "), _c('span', {
      style: ({
        color: value.color_code
      })
    }, [_vm._v("\n                  " + _vm._s(value.proficiency_score || 0) + _vm._s(_vm.$t('common.score_value')) + "\n                ")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-6 domain-action",
      style: ({
        color: value.color_code
      })
    }, [_c('span', {
      on: {
        "click": function($event) {
          return _vm.openCreatedLearningViewer(value.domain_id, false)
        }
      }
    }, [_vm._v("\n                " + _vm._s(_vm.$t('common.problem_solve')) + " >\n              ")])])] : (value.cat && value.cat.is_first_cat) ? [_c('div', {
      staticClass: "col-6 domain-score"
    }, [_c('strong', {
      style: ({
        color: value.color_code
      })
    }, [_vm._v("\n                " + _vm._s(_vm.quizProgressValue(value.cat.quiz_results.length, value.cat.quiz_count)) + "%\n              ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-6 domain-action",
      style: ({
        color: value.color_code
      })
    }, [_c('span', {
      on: {
        "click": function($event) {
          return _vm.openLearningViewer(value.cat && value.cat.viewer_url, true)
        }
      }
    }, [_vm._v("\n                " + _vm._s(_vm.$t('common.continu_solve')) + " >\n              ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-12 domain-progress-bar"
    }, [_c('progress-bar', {
      attrs: {
        "value": _vm.quizProgressValue(value.cat.quiz_results.length, value.cat.quiz_count),
        "bgColor": value.color_code,
        "height": 6,
        "isBorderStyle": true
      }
    })], 1)] : (value.cat && !value.cat.is_completed) ? [_c('div', {
      staticClass: "col-6 domain-score"
    }, [_vm._v("\n              " + _vm._s(_vm.$t('common.score')) + " \n              "), _c('span', {
      style: ({
        color: value.color_code
      })
    }, [_vm._v("\n                " + _vm._s(value.proficiency_score || 0) + _vm._s(_vm.$t('common.score_value')) + "\n              ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-6 domain-action",
      style: ({
        color: value.color_code
      })
    }, [_c('span', {
      on: {
        "click": function($event) {
          return _vm.openLearningViewer(value.cat && value.cat.viewer_url)
        }
      }
    }, [_vm._v("\n                " + _vm._s(_vm.$t('common.continu_solve')) + " >\n              ")])])] : _vm._e()], 2)])
  })], _vm._v(" "), (_vm.isPrimeModal) ? _c('PrimeModal', {
    attrs: {
      "benefitTitle": _vm.$t('prime.first_solve_complete'),
      "isUnsupportText": true
    },
    on: {
      "closeModal": function($event) {
        return _vm.closePrimeModal()
      },
      "okModal": function($event) {
        return _vm.okPrimeModal()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isLicenceModal) ? _c('LicenceModal', {
    on: {
      "ok": function($event) {
        _vm.isLicenceModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('b-modal', {
    ref: "modal",
    staticClass: "preview-domain-modal",
    attrs: {
      "id": "previewDomainModal",
      "centered": "",
      "hide-header": "",
      "hide-footer": ""
    }
  }, [_vm._t("default", [_c('div', {
    staticClass: "preview-domain"
  }, [_c('div', {
    staticClass: "preview-domain-header"
  }, [_vm._v(_vm._s(_vm.$t('common.not_support_grade')))]), _vm._v(" "), _c('div', {
    staticClass: "preview-domain-body"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/img_sample_sam.png",
      "alt": "icon"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "preview-domain-footer"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleCloseClick
    }
  }, [_vm._v("\n              " + _vm._s(_vm.$t('common.confirmation')) + "\n            ")])])])])], 2)], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "dummy-domain-subject"
  }), _vm._v(" "), _c('div', {
    staticClass: "dummy-domain-title"
  }), _vm._v(" "), _c('div', {
    staticClass: "dummy-domain-action"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01208bfb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/cat-main/components/CatDomain.vue
// module id = 1546
// module chunks = 1